










































































import { Component, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import ShopApi from '@/api/shopInfo/index'
import appconst from '@/lib/appconst'
@Component({
  components: {
    CustomForm,
  },
})
export default class Shop extends AbpBase {
  loading = false
  authShowModal: boolean = false
  prestorageModal: boolean = false
  money: any = null
  selectAuthList: any[] = []
  selectItem: any = {}
  qrCodeUrl = `${appconst.remoteServiceBaseUrl}/api/WeChatManagement/Weixin/qrcode/`
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
  }
  filters = [
    {
      label: '店铺：',
      type: 'input',
      props: {
        placeholder: '店铺ID/账号',
      },
      key: 'KeyWord',
    },
    // {
    //   label: '所属渠道：',
    //   type: 'input',
    //   props: {
    //     placeholder: '用户昵称',
    //   },
    //   key: 'KeyWord',
    // },
    // {
    //   label: '区域：',
    //   type: 'select',
    //   key: 'Categories',
    //   defaultValue: [],
    //   props: {
    //     // 'max-tag-count': 2,
    //     // multiple: true,
    //     placeholder: '请选择',
    //   },
    //   options: [],
    // },
    // {
    //   label: '状态名称：',
    //   type: 'select',
    //   key: 'Categories',
    //   defaultValue: [],
    //   props: {
    //     // 'max-tag-count': 2,
    //     // multiple: true,
    //     placeholder: '请选择',
    //   },
    //   options: [],
    // },
    // {
    //   label: '负责人：',
    //   type: 'input',
    //   props: {
    //     placeholder: '请输入负责人姓名',
    //   },
    //   key: 'manager',
    // },
    // {
    //   label: '门店电话：',
    //   type: 'input',
    //   props: {
    //     placeholder: '请输入门店电话',
    //   },
    //   key: 'phone',
    // },
  ]
  columns1 = [
    {
      title: '代码',
      key: 'code',
      align: 'center',
    },
    {
      title: '店铺名称',
      key: 'displayName',
      align: 'center',
    },
    {
      title: '负责人',
      key: 'manager',
      align: 'center',
    },
    {
      title: '订金',
      key: 'deposit',
      align: 'center',
    },
    {
      title: '余额',
      key: 'balance',
      align: 'center',
    },
    {
      title: '现货折扣',
      key: 'spotDiscount',
      align: 'center',
    },
    {
      title: '期货折扣',
      key: 'futuresDiscount',
      align: 'center',
    },
    {
      title: '状态名称',
      key: 'isActive',
      slot: 'isActive',
      align: 'center',
    },
    // {
    //   title: '区域',
    //   key: 'district',
    //   align: 'center',
    // },
    {
      title: '详细地址',
      key: 'detailAddress',
      align: 'center',
    },
    {
      title: '门店电话',
      key: 'phone',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
      width: 300,
    },
  ]
  data1 = [
    {
      displayName: '1231',
      code: 'sadasd',
      detailAddress: 'adqwe123',
      isActive: true,
    },
  ]
  mounted() {
    this.loadData()
  }
  onPageIndexChange(value) {
    this.pager.pageIndex = value
    let form = (this.$refs.lineForm as any).form
    this.loadData(form)
  }
  submitChange(form, valid) {
    if (valid) {
      this.pager.pageIndex = 1
      this.loadData(form)
    }
  }
  loadData(form = {}) {
    let keyWord = form['KeyWord']
    this.loading = true
    ShopApi.getList2(this.pager.pageSize, this.pager.pageIndex, keyWord).then((res) => {
      if(res.data && res.data.items.length) {
        res.data.items.forEach(item => {
          if(item.shopPermissionsConfig) {
            item.shopPermissionsConfig = item.shopPermissionsConfig.split(',')
          }
        })
        this.pager.total = res.data.totalCount
        this.data1 = res.data.items
      }
      this.loading = false
    })
  }
  handleCommonAction(row, type) {
    switch (type) {
      case 'storage':
        this.money = null
        this.selectItem = row
        this.prestorageModal = true
        break;
      case 'auth':
        if(row.shopPermissionsConfig) {
          this.selectAuthList = row.shopPermissionsConfig
        }else {
          this.selectAuthList = []
        }
        this.selectItem = row
        this.authShowModal = true
        break
      case 'look':
        this.$router.push({
          name: 'storeDetail',
          query: {
            id: row.id,
          },
        })
        break
      case 'edit':
        this.handleEditStore(row)
        break
      case 'delete':
        this.handleDeleteStore(row)
        break
      default:
        break
    }
  }
  submitAuth() {
    // 提交权限
    let configStr = this.selectAuthList.join()
    ShopApi.shopPermissionConfig(this.selectItem.id, configStr).then(res => {
      this.$Notice.success({
        desc: '操作成功'
      })
      let form = (this.$refs.lineForm as any).form
    this.loadData(form)
      this.authShowModal = false
    })
  }
  // 编辑店铺
  handleEditStore(row) {
    console.log(row)
    this.$router.push({
      name: 'editStore',
      query: {
        id: row.id,
      },
    })
  }
  // 保存预存金额
  submitPre() {
    if(!this.money) {
      this.$Message.warning('请输入金额');
      return
    }
    this.$Modal.confirm({
      title: '提示',
      content: `是否确认此操作?`,
      onOk: () => {
        let obj = {
          storeId: this.selectItem.id,
          amount: this.money
        }
        ShopApi.recharge(obj).then(res => {
          this.$Notice.success({ desc: '预存成功' })
          this.loadData()
          this.prestorageModal = false
        })
      },
    })
  }
  /* 
    删除店铺
   */
  handleDeleteStore(row) {
    console.log(row)
    const ids: any[] = []
    ids.push(row.id)
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        ShopApi.deleteStoreInfo(ids)
          .then((res) => {
            console.log(res)
            this.loading = false
            this.$Notice.success({ desc: '删除成功' })
            this.loadData()
          })
          .catch((err) => {
            this.loading = false
          })
      },
    })
  }
  /**
   * 添加店铺
   */
  handleAddShop() {
    this.$router.push({
      name: 'addStore',
    })
  }
}
